import React from "react";
import _ from "lodash";
import { connect } from "formik";
import { TextAreaInput } from "components/Global/FormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const SideLabelTextAreaInput = ({ label, fieldName, placeholder, formik, isDisabled, ...otherProps }) => {
  const val = _.get(formik.values, fieldName);

  return (
    <LateralField label={label}>
      {isDisabled && <ViewOnlyDiv>{val}</ViewOnlyDiv>}
      {!isDisabled && <TextAreaInput
        fullWidth
        fieldName={fieldName}
        placeholder={placeholder}
      />}
    </LateralField>
  );
};
export default connect(SideLabelTextAreaInput);
